import React from "react";
import { HelpCircleIcon } from "lucide-react";
import { SectionHeading } from "./SectionHeading";
import { CtaButton } from "./CtaButton";
import { diagnosticQuestions } from "../data/content";
export function CollectionIntro() {
  return <section className="w-full bg-white px-5 py-16 sm:py-20" data-id="element-81" data-mp="1ldl1rbltq1z">
      <SectionHeading eyebrow="The BCM Diagnostic Blueprint™ Collection" title={<>
            Six Volumes. Five Bonuses. <span className="text-brand" data-id="element-83" data-mp="350regmvuqfnv">One Structured Approach.</span>
          </>} data-id="element-82" data-mp="3ss6lgsykpl5g" />
      <div className="mx-auto mt-8 max-w-2xl space-y-5 text-lg leading-relaxed text-muted" data-id="element-84" data-mp="301o7uy0841ds">
        <p data-id="element-85" data-mp="3etzw617owthe">If you work with automotive electronics, you already know how frustrating BCM-related problems can be.</p>
        <p data-id="element-86" data-mp="3a040x6it9kpx">
          You connect your diagnostic equipment. You retrieve the fault codes. You check the symptoms reported by the
          customer. But then you face the question that can turn a seemingly straightforward job into a complicated
          investigation:
        </p>
        <p className="rounded-2xl bg-navy px-6 py-6 text-center font-display text-3xl font-black italic text-white" data-id="element-87" data-mp="1xo2skakh9eet">
          “What should I check next?”
        </p>
        <ul className="space-y-3" data-id="element-88" data-mp="26ho6jrotirn6">
          {diagnosticQuestions.map(q => <li key={q} className="flex gap-3 font-medium text-navy" data-id="element-89" data-mp="2bg957mof939i">
              <HelpCircleIcon className="mt-1 h-5 w-5 shrink-0 text-brand" aria-hidden="true" data-id="element-90" data-mp="2bhkd9yowgx6f" />
              {q}
            </li>)}
        </ul>
        <p data-id="element-91" data-mp="1irtuvdg8j94i">
          The symptoms may point in several directions, and replacing a module based on assumptions can lead to{" "}
          <strong className="text-alert" data-id="element-92" data-mp="1ns85925b6v5p">unnecessary costs and unresolved problems.</strong>
        </p>
        <p data-id="element-93" data-mp="1sn5cc3j12ufy">
          That's exactly why I created the <strong className="text-navy" data-id="element-94" data-mp="2z63ha20x2nsp">BCM Diagnostic Blueprint™</strong> — a
          practical system that helps you organize the information you already have, separate confirmed findings from
          possible causes, and plan your next investigative step based on evidence and vehicle-specific service
          information.
        </p>
        <p data-id="element-95" data-mp="29gwn6q2k02sg">
          Instead of jumping between disconnected notes, diagrams, and diagnostic resources, you'll have a structured
          framework from the initial symptom through final documentation.
        </p>
      </div>
      <div className="mt-10" data-id="element-96" data-mp="1vprobq70fej6">
        <CtaButton note="One-Time Payment · No Monthly Fees · Lifetime Access" data-id="element-97" data-mp="1voylh0b6996b">Get Instant Access for $27</CtaButton>
      </div>
    </section>;
}